import { toast } from "react-toastify";
import fire from "../../config/fire";



const setPostsLoading = (message) => ({
  type: "SET_POSTS_LOADING",
  payload: message,
});
const setPosts = (data) => ({
  type: "SET_POSTS",
  payload: data,
});


export const getPosts = () => async (dispatch) => {
  dispatch(setPostsLoading(true));

  const posts = await fire.firestore().collection("ENGLISH").get();
  const posts1 = await fire.firestore().collection("SWAHILI").get();
  // const posts2 = await fire.firestore().collection("BEMBA").get();
  const posts3 = await fire.firestore().collection("NewandHot").get();
  const posts4 = await fire.firestore().collection("EditorPicks").get();
  const posts5 = await fire.firestore().collection("FromOurStarts").get();
  const posts6 = await fire.firestore().collection("Genre").get();
  const posts7 = await fire.firestore().collection("Action").get();
  const posts8 = await fire.firestore().collection("Action and adventure").get();
  const posts9 = await fire.firestore().collection("Fantasy").get();
  const posts1a = await fire.firestore().collection("Historical Fiction").get();
  const posts1b = await fire.firestore().collection("Poetry").get();
  const posts1c = await fire.firestore().collection("Fiction").get();
  const posts1d = await fire.firestore().collection("Diary").get();
  const posts1e = await fire.firestore().collection("Alternate history").get();
  const posts1f = await fire.firestore().collection("Autobiography").get();
  const posts1g = await fire.firestore().collection("Biography").get();
  const posts1h = await fire.firestore().collection("Comic book").get();
  const posts2a = await fire.firestore().collection("Adventure").get();
  const posts2b = await fire.firestore().collection("BunnerStories").get();

  const postsAd1 = await fire.firestore().collection("StoryAd1").get();
  const postsAd2 = await fire.firestore().collection("StoryAd2").get();
  const postsAd3 = await fire.firestore().collection("StoryAd3").get();
  const postsAd4 = await fire.firestore().collection("StoryAd4").get();

  const book1 = await fire.firestore().collection("Books").get();
  const book2 = await fire.firestore().collection("Books").doc('file: Fantasy ').collection('file: Fantasy ').get();

  const allPosts = [];

  posts.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts1.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  // posts2.forEach((post) => {
  //   if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
  //     allPosts.push({ post: post.data(), postId: post.id });
  //   }
  // });

  posts3.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts4.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts5.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts6.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts7.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts8.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts9.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts1a.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts1b.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts1c.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts1d.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts1e.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts1f.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts1g.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts1h.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts2a.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  posts2b.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

 




  postsAd1.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  postsAd2.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  postsAd3.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });
  postsAd4.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });



  book1.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  book2.forEach((post) => {
    if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
    }
  });

  dispatch(setPostsLoading(false));
  dispatch(setPosts(allPosts));
};

const addPost = (post) => ({
  type: "ADD_POST",
  payload: post,
});

export const newPost =
  (data, author, nameAuthor, setProgress) => (dispatch) => {
    fire
      .firestore()
      .collection(`${data.language}`)
      .add({
        title: data.title,
        timestamp: data.timestamp,
        date: data.date,
        category: data.category,
        language: data.language,
        description: data.description,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        image: null,
        author,
        likes: 0,
        comments: [],
        postedBy: nameAuthor,
      })
      .then((doc) => {
        const fileUpload = fire
          .storage()
          .ref(`${data.language}/${doc.id}`)
          .put(data.image);

        fileUpload.on(
          "state_changed",
          (snapshot) => {
            const progress =
              Math.round(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setProgress(progress);
          },
          (error) => {
            return toast.error(error.message);
          },
          () => {
            fileUpload.snapshot.ref.getDownloadURL().then((downloadURL) => {
              fire
                .firestore()
                .collection(`${data.language}`)
                .doc(doc.id)
                .update({
                  image: downloadURL,
                  id: doc.id
                })
                .then(async (post) => {
                  const docum = await doc.get();
                  const docData = docum.data();
                  docData.image = downloadURL;
                  dispatch(addPost({ data: docData, postId: doc.id }));
                });
            });
          }
        );
      });
  };

const addComment = (data) => ({
  type: "ADD_COMMENT",
  payload: data,
});

export const doComment = (id, comments, data) => (dispatch) => {
  fire
    .firestore()
    .collection(`${data.language}`)
    .doc(id)
    .update({ comments: [...comments, data], updatedAt: Date.now() })
    .then(async () => {
      dispatch(addComment({ id, comment: data }));
    });
};

const addReply = (data) => ({
  type: "ADD_REPLY",
  payload: data,
});
export const doReply = (i, postId, comments, reply, data) => (dispatch) => {
  // console.log(id, comments, name, email, reply);
  const currentComment = comments.find((comment, id) => i === id);
  currentComment.replies = [...currentComment.replies, reply];
  const updatedComments = comments.map((comment, id) =>
    id === i ? currentComment : comment
  );
  fire
    .firestore()
    .collection(`${data.language}`)
    .doc(postId)
    .update({ comments: updatedComments, updatedAt: Date.now() })
    .then(async () => {
      dispatch(addReply({ id: i, postId, updatedComments }));
    });
};

const removeComment = (data) => ({
  type: "DELETE_COMMENT",
  payload: data,
});

export const deleteComment = (id, postId, comments, data) => (dispatch) => {
  const filteredComments = comments.filter((comment, i) => i !== id);
  fire
    .firestore()
    .collection(`${data.language}`)
    .doc(postId)
    .update({
      comments: filteredComments,
      updatedAt: Date.now(),
    })
    .then(() => {
      dispatch(removeComment({ filteredComments, postId }));
    });
};

const deletePost = (postId) => ({
  type: "DELETE_POST",
  payload: postId,
});

export const postDel = (postId, data) => (dispatch) => {
  fire
    .storage()
    .ref(`${data.language}/${postId}`)
    .delete()
    .then(() => {
      fire
        .firestore()
        .collection(`${data.language}`)
        .doc(postId)
        .delete()
        .then(() => {
          dispatch(deletePost(postId));
        });
    });
};

const updatePost = (data) => ({
  type: "UPDATE_POST",
  payload: data,
});

export const postUpdate = (postId, data) => (dispatch) => {
  fire
    .firestore()
    .collection(`${data.language}`)
    .doc(postId)
    .update({
      title: data.title,
      language: data.language,
      category: data.category,
      description: data.description,
    })
    .then(() => {
      dispatch(updatePost({ postId, data }));
    });
};
